<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container [ngSwitch]="modalType">
    <div *ngSwitchCase="'view'" class="container-fluid">
      <!-- Your existing view template -->
    </div>

    <div *ngSwitchCase="'delete'">
      <p>Are you sure you want to delete this order?</p>
      <div class="alert alert-warning">
        <strong>Order #{{ order.orderNumber }}</strong> will be permanently
        removed.
      </div>
    </div>

    <div *ngSwitchCase="'status'">
      <p>
        Are you sure you want to {{ getActionDisplayText(actionType) }} this
        order?
      </p>

      <div *ngIf="isOutForDelivery() && outForDeliveryDefaultsApplied" class="mt-3">
        <div class="form-group">
          <label for="riderMobile">Rider Mobile Number</label>
          <ngx-intl-tel-input
            style="display: block; width: 100%"
            class="country_code"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="riderCountryISO"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="separateDialCode"
            [numberFormat]="PhoneNumberFormat.National"
            [(ngModel)]="riderPhone"
            (countryChange)="onRiderCountryChange($event)"
            name="riderPhone"
          >
          </ngx-intl-tel-input>
        </div>
        <div class="form-group mt-2">
          <label for="message">Message</label>
          <textarea
            class="form-control"
            id="message"
            [(ngModel)]="message"
            rows="3"
            placeholder="Message to customer"
          ></textarea>
        </div>
      </div>

      <div *ngIf="requiresReason">
        <div class="form-group mt-3">
          <label for="reason">Reason (Required)</label>
          <textarea
            class="form-control"
            [(ngModel)]="reason"
            id="reason"
            rows="3"
            [ngClass]="{ 'is-invalid': requiresReason && !reason }"
          ></textarea>
          <div class="invalid-feedback" *ngIf="requiresReason && !reason">
            Please provide a reason for this action
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="activeModal.dismiss()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="(requiresReason && !reason) || (isOutForDelivery() && !hasValidRiderMobile())"
    (click)="activeModal.close(getConfirmPayload())"
  >
    {{ modalType === "delete" ? "Delete" : "Confirm" }}
  </button>
</div>
